exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit svg:hover path {\n  stroke: #4caf50;\n}", ""]);

// exports
